import React from 'react';

const Footer: React.FC = () => {
    return (
        <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white mt-auto relative overflow-hidden">
            {/* Background decoration */}
            <div className="absolute inset-0 opacity-5">
                <div className="absolute top-0 left-0 w-96 h-96 bg-accent rounded-full -translate-x-48 -translate-y-48"></div>
                <div className="absolute bottom-0 right-0 w-96 h-96 bg-primary rounded-full translate-x-48 translate-y-48"></div>
            </div>

            <div className="container mx-auto px-4 py-12 relative">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {/* Company Info */}
                    <div className="group">
                        <div className="text-3xl font-bold text-accent mb-4 group-hover:scale-105 transition-transform duration-300">
                            Eldaï
                        </div>
                        <p className="text-gray-300 text-sm mb-6 leading-relaxed">
                            Votre grossiste en produits casher de confiance.
                            Qualité et service d'excellence depuis des années.
                        </p>
                        <div className="space-y-3 text-sm text-gray-300">
                            <div className="flex items-center space-x-3 hover:text-accent transition-colors duration-300 cursor-pointer group">
                                <span className="text-lg group-hover:scale-110 transition-transform duration-300">📧</span>
                                <a href="mailto:contact@eldai.fr" className="hover:text-accent transition-colors">
                                    contact@eldai.fr
                                </a>
                            </div>
                            <div className="flex items-center space-x-3 hover:text-accent transition-colors duration-300 cursor-pointer group">
                                <span className="text-lg group-hover:scale-110 transition-transform duration-300">📞</span>
                                <a href="tel:0123456789" className="hover:text-accent transition-colors">
                                    01 23 45 67 89
                                </a>
                            </div>
                            <div className="flex items-center space-x-3 hover:text-accent transition-colors duration-300 group">
                                <span className="text-lg group-hover:scale-110 transition-transform duration-300">📍</span>
                                <span>Paris, France</span>
                            </div>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h3 className="font-semibold mb-6 text-lg text-white">Liens rapides</h3>
                        <ul className="space-y-3 text-sm text-gray-300">
                            <li>
                                <a href="/catalog" className="hover:text-accent transition-all duration-300 flex items-center space-x-2 group hover:translate-x-1">
                                    <span className="group-hover:text-accent transition-colors duration-300">→</span>
                                    <span>Catalogue produits</span>
                                </a>
                            </li>
                            <li>
                                <a href="/about" className="hover:text-accent transition-all duration-300 flex items-center space-x-2 group hover:translate-x-1">
                                    <span className="group-hover:text-accent transition-colors duration-300">→</span>
                                    <span>À propos</span>
                                </a>
                            </li>
                            <li>
                                <a href="/contact" className="hover:text-accent transition-all duration-300 flex items-center space-x-2 group hover:translate-x-1">
                                    <span className="group-hover:text-accent transition-colors duration-300">→</span>
                                    <span>Contact</span>
                                </a>
                            </li>
                            <li>
                                <a href="/terms" className="hover:text-accent transition-all duration-300 flex items-center space-x-2 group hover:translate-x-1">
                                    <span className="group-hover:text-accent transition-colors duration-300">→</span>
                                    <span>Conditions de vente</span>
                                </a>
                            </li>
                            <li>
                                <a href="/privacy" className="hover:text-accent transition-all duration-300 flex items-center space-x-2 group hover:translate-x-1">
                                    <span className="group-hover:text-accent transition-colors duration-300">→</span>
                                    <span>Politique de confidentialité</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* Service Info */}
                    <div>
                        <h3 className="font-semibold mb-6 text-lg text-white">Service client</h3>
                        <div className="space-y-4 text-sm text-gray-300">
                            <div className="bg-gray-800 bg-opacity-50 p-3 rounded-lg border border-gray-700 hover:border-accent transition-colors duration-300">
                                <div className="flex items-center space-x-3 mb-2">
                                    <span className="text-lg">⏰</span>
                                    <span className="font-medium text-white">Horaires d'ouverture</span>
                                </div>
                                <div className="ml-6 space-y-1 text-xs">
                                    <div>Lun-Jeu: 8h-17h</div>
                                    <div>Vendredi: 8h-15h</div>
                                </div>
                            </div>

                            <div className="space-y-3">
                                <div className="flex items-center space-x-3 hover:text-accent transition-colors duration-300 group">
                                    <span className="text-lg group-hover:scale-110 transition-transform duration-300">🚚</span>
                                    <span>Livraison partout en France</span>
                                </div>
                                <div className="flex items-center space-x-3 hover:text-accent transition-colors duration-300 group">
                                    <span className="text-lg group-hover:scale-110 transition-transform duration-300">💳</span>
                                    <span>Paiement à la livraison</span>
                                </div>
                                <div className="flex items-center space-x-3 hover:text-accent transition-colors duration-300 group">
                                    <span className="text-lg group-hover:scale-110 transition-transform duration-300">✅</span>
                                    <span>Certification casher garantie</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Social Media & Copyright */}
                <div className="border-t border-gray-700 mt-12 pt-8">
                    <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
                        <div className="text-sm text-gray-400">
                            <p>&copy; 2024 Eldaï. Tous droits réservés.</p>
                        </div>

                        {/* Social Links Placeholder */}
                        <div className="flex items-center space-x-4">
                            <span className="text-sm text-gray-400">Suivez-nous:</span>
                            <div className="flex space-x-3">
                                <div className="w-8 h-8 bg-gray-700 hover:bg-accent rounded-full flex items-center justify-center transition-colors duration-300 cursor-pointer group">
                                    <span className="text-sm group-hover:scale-110 transition-transform duration-300">📘</span>
                                </div>
                                <div className="w-8 h-8 bg-gray-700 hover:bg-accent rounded-full flex items-center justify-center transition-colors duration-300 cursor-pointer group">
                                    <span className="text-sm group-hover:scale-110 transition-transform duration-300">📧</span>
                                </div>
                                <div className="w-8 h-8 bg-gray-700 hover:bg-accent rounded-full flex items-center justify-center transition-colors duration-300 cursor-pointer group">
                                    <span className="text-sm group-hover:scale-110 transition-transform duration-300">📱</span>
                                </div>
                            </div>
                        </div>

                        <div className="text-sm text-gray-400">
                            <p>Fait avec ❤️ pour la communauté</p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
